import { assign, createMachine } from "xstate";
import { setPaymentRequestAsPaid } from "../usecases/setPaymentRequestAsPaid";

interface Context {
    isModalOpen: boolean;
    error?: any;
}

export enum PaymentAlreadyPaidMachineState {
    Initial = "initial",
    Submitting = "submitting",
    Success = "success",
}

export const paymentAlreadyPaidMachine = createMachine<Context>({
    id: "paymentAlreadyPaidMachine",
    initial: PaymentAlreadyPaidMachineState.Initial,
    context: {
        isModalOpen: false,
    },
    states: {
        [PaymentAlreadyPaidMachineState.Initial]: {
            on: {
                TOGGLE_MODAL: {
                    actions: assign({
                        isModalOpen: (context) => !context.isModalOpen,
                    }),
                },
                SUBMIT: PaymentAlreadyPaidMachineState.Submitting,
            },
        },
        [PaymentAlreadyPaidMachineState.Submitting]: {
            invoke: {
                src: (_context, event) =>
                    setPaymentRequestAsPaid(event.token, event.note),
                onDone: {
                    target: PaymentAlreadyPaidMachineState.Success,
                    actions: assign({
                        isModalOpen: (_context) => false,
                    }),
                },
                onError: {
                    target: PaymentAlreadyPaidMachineState.Initial,
                    actions: [
                        assign({
                            error: (_, event) => event.data,
                        }),
                        "notifyErrorSettingAlreadyPaid",
                    ],
                },
            },
        },
        [PaymentAlreadyPaidMachineState.Success]: {
            type: "final",
            invoke: {
                src: "reloadPage",
            },
        },
    },
});
